import { RiAddLine, RiRefreshLine, RiShoppingBag3Line } from "react-icons/ri";
import styles from "./OrdersToolbar.module.css";

const OrdersToolbar = ({ totalOrders = 0, onRefresh, onCreateOrder }) => (
  <header className={styles.pageHeader}>
    <div className={styles.pageIdentity}>
      <span className={styles.pageIcon}>
        <RiShoppingBag3Line aria-hidden="true" />
      </span>
      <h1 className={styles.pageTitle}>Orders</h1>
      <span className={styles.orderCount}>{totalOrders} orders</span>
    </div>
    <div className={styles.globalActions}>
      <button
        type="button"
        className={styles.refreshAction}
        onClick={onRefresh}
        aria-label="Refresh orders"
        title="Refresh orders"
      >
        <RiRefreshLine aria-hidden="true" />
        <span>Refresh</span>
      </button>
      <button
        type="button"
        className={styles.createAction}
        onClick={onCreateOrder}
        aria-label="Create order"
      >
        <RiAddLine aria-hidden="true" />
        <span>Create order</span>
      </button>
    </div>
  </header>
);

export default OrdersToolbar;
